import { useTracking, EVENTS } from "../../Tracking";
import { useAuth } from "../../auth/AuthProvider";
import { useCustomer } from "../../auth/CustomerProvider";
import { ExternalButtonLink } from "@teamscheme/button-link";
import { InfoAlert } from "@teamscheme/alert";

export default function LinkCrmInfoBox() {
  const customer = useCustomer();
  const auth = useAuth();
  const tracking = useTracking();
  const loggedInWithoutMembership =
    !customer.isLoading &&
    auth.isAuthenticated &&
    (!customer.result || !customer.result.hasMembership);
  const linkUrl =
    window.location.host === "kjopekontrakt.naf.no"
      ? "https://profil.id.naf.no/koble-medlemskap"
      : "https://stage.profil.id.naf.no/koble-medlemskap";
  const loggedInIdentity = customer.result
    ? customer.result.firstName || customer.result.lastName
      ? `${[customer.result.firstName, customer.result.lastName]
          .filter((p) => !!p)
          .join(" ")} ${
          customer.result.email ? `(${customer.result.email})` : ""
        }`
      : customer.result.email
    : null;
  return loggedInWithoutMembership ? (
    <InfoAlert>
      <p>
      Du er logget inn som {loggedInIdentity}. Vi fant ikke et gyldig medlemskap
      på din profil. Er ikke dette riktig?
      </p>
      <ExternalButtonLink
        variant="secondary"
        href={`${linkUrl}?onSuccessReturnUrl=${encodeURIComponent(
          window.location.href
        )}`}
        onClick={() => tracking.event(EVENTS.CONTRACT_TYPES.OPEN_LINK_SERVICE)}
      >
        Koble medlemskap
      </ExternalButtonLink>
    </InfoAlert>
  ) : null;
}
